module.exports = __webpack_public_path__ + "4777551eff1ff50c5d45a0e650f69539.svg";


//////////////////
// WEBPACK FOOTER
// ./app/images/test-step-3.svg
// module id = 487
// module chunks = 0